import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-externalauth',
  templateUrl: './externalauth.component.html',
  styleUrls: ['./externalauth.component.css']
})
export class ExternalauthComponent implements OnInit {
  islecturer: any;
  constructor(private activatedroute: ActivatedRoute, private userservice: UseraccessserviceService, private router: Router, private toastr: ToastrService, private util: UtilService
  ) { }

  async ngOnInit() {
    const jwt = this.activatedroute.snapshot.queryParams.jwt;
    this.userservice.setAuthenticatedUserToken(jwt);
    this.islecturer = this.activatedroute.snapshot.queryParams.lecturer;
    try{
      await this.util.logactivity(
        {
          "ActivityType": 1,
          "ModuleId": 0,
          "ClassId": 0,
          "AssessmentId": 0,
        }        
      ).toPromise();
    }
    catch (e){
      console.log(e);
      this.toastr.warning(e)
    }
    if (this.islecturer === "true") {
      this.router.navigate(['/user/usermodules']);
    }
    else
      this.router.navigate(['/']);
  }

}
